export default "__VITE_ASSET__CRgImkWA__"